import { pxToRem } from '../../../../utils';
export default (function (siteVars) {
  return {
    color: siteVars.colorScheme["default"].foreground,
    padding: "".concat(pxToRem(1), " 0")
  };
});